// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"st_wrapper__dobLH","swiperContainer":"st_swiperContainer__a4TEk","slide":"st_slide__BjrpB"};